// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GateRequestSuccessModal_backdrop__aZo2R {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1300;
}

.GateRequestSuccessModal_modal__rk8He {
  width: 760px;
  max-width: calc(100% - 32px);
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.12);
  overflow: hidden;
}

.GateRequestSuccessModal_header__iFWut {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 32px;
  border-bottom: 1px solid #e5e7eb;
}

.GateRequestSuccessModal_title__d2mWl {
  color: var(--Slate-700, #334155);

  /* Inter/Body xl/Body xl - semibold */
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px; /* 150% */
  margin: 0;
}

.GateRequestSuccessModal_iconBtn__XT5Cz {
  border: none;
  background: transparent;
  cursor: pointer;
  color: #64748b;
}

.GateRequestSuccessModal_content__RNMuP { padding: 24px 32px; }

.GateRequestSuccessModal_centerBlock__Z-nBD {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
  margin-bottom: 16px;
}

.GateRequestSuccessModal_successIcon__6MrOh {
  color: #16a34a;
  background: #ecfdf5;
  border-radius: 999px;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.GateRequestSuccessModal_successTitle__kQufp {
  color: var(--Green-700, #15803D);
  text-align: center;
  
  /* Inter/Body md/Body md - semibold */
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  margin: 0;
}

.GateRequestSuccessModal_successSub__oL-Op {
  color: var(--Green-800, #166534);
  text-align: center;
  
  /* Inter/Body small/Body small - regular */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  margin: 0;
  margin-bottom: 16px;
}

.GateRequestSuccessModal_detailsGrid__\\+m8f6 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px 24px;
  margin-top: 12px;
}

.GateRequestSuccessModal_label__cBRbI {
  margin: 0 0 4px 0;
  color: var(--Gray-500, #6B7280);

  /* Inter/Body small/Body small - regular */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
}

.GateRequestSuccessModal_value__KFHAH {
  color: var(--Gray-800, #1F2937);

  /* Inter/Body small/Body small - regular */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  margin: 0;
}

.GateRequestSuccessModal_reasonBlock__sInm3 { grid-column: 1 / -1; }

.GateRequestSuccessModal_footer__0YDwq {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 24px 32px;
  border-top: 1px solid #e5e7eb;
}

.GateRequestSuccessModal_cancelBtn__te1zV {
  color: #111827;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  border-radius: 10px;
  height: 40px;
  padding: 0 16px;
  font-weight: 600;
  text-transform: none;
  box-shadow: none;
}

.GateRequestSuccessModal_cancelBtn__te1zV:hover {
  background: #F9FAFB;
  border-color: #d1d5db;
  box-shadow: none;
}

.GateRequestSuccessModal_primaryBtn__6Kqhj {
  background: #5b3df4;
  color: #ffffff;
  border-radius: 10px;
  height: 40px;
  padding: 0 16px;
  font-weight: 600;
  text-transform: none;
  box-shadow: 0 2px 6px rgba(91, 61, 244, 0.3);
}

.GateRequestSuccessModal_primaryBtn__6Kqhj:hover {
  background: #4f33e1;
}

.GateRequestSuccessModal_primaryBtn__6Kqhj:disabled {
  background: #A5B4FC;
  color: #EEF2FF;
  box-shadow: none;
}


`, "",{"version":3,"sources":["webpack://./src/views/StudentGatePass/components/GateRequestSuccessModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;;EAEhC,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA,0CAAW,kBAAkB,EAAE;;AAE/B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;;EAElB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;;EAElB,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;;EAE/B,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,+BAA+B;;EAE/B,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,SAAS;AACX;;AAEA,8CAAe,mBAAmB,EAAE;;AAEpC;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1300;\n}\n\n.modal {\n  width: 760px;\n  max-width: calc(100% - 32px);\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.12);\n  overflow: hidden;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 32px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.title {\n  color: var(--Slate-700, #334155);\n\n  /* Inter/Body xl/Body xl - semibold */\n  font-family: Inter;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 30px; /* 150% */\n  margin: 0;\n}\n\n.iconBtn {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: #64748b;\n}\n\n.content { padding: 24px 32px; }\n\n.centerBlock {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.successIcon {\n  color: #16a34a;\n  background: #ecfdf5;\n  border-radius: 999px;\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.successTitle {\n  color: var(--Green-700, #15803D);\n  text-align: center;\n  \n  /* Inter/Body md/Body md - semibold */\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px; /* 150% */\n  margin: 0;\n}\n\n.successSub {\n  color: var(--Green-800, #166534);\n  text-align: center;\n  \n  /* Inter/Body small/Body small - regular */\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n  margin: 0;\n  margin-bottom: 16px;\n}\n\n.detailsGrid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px 24px;\n  margin-top: 12px;\n}\n\n.label {\n  margin: 0 0 4px 0;\n  color: var(--Gray-500, #6B7280);\n\n  /* Inter/Body small/Body small - regular */\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n}\n\n.value {\n  color: var(--Gray-800, #1F2937);\n\n  /* Inter/Body small/Body small - regular */\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n  margin: 0;\n}\n\n.reasonBlock { grid-column: 1 / -1; }\n\n.footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 24px 32px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.cancelBtn {\n  color: #111827;\n  border: 1px solid #e5e7eb;\n  background: #ffffff;\n  border-radius: 10px;\n  height: 40px;\n  padding: 0 16px;\n  font-weight: 600;\n  text-transform: none;\n  box-shadow: none;\n}\n\n.cancelBtn:hover {\n  background: #F9FAFB;\n  border-color: #d1d5db;\n  box-shadow: none;\n}\n\n.primaryBtn {\n  background: #5b3df4;\n  color: #ffffff;\n  border-radius: 10px;\n  height: 40px;\n  padding: 0 16px;\n  font-weight: 600;\n  text-transform: none;\n  box-shadow: 0 2px 6px rgba(91, 61, 244, 0.3);\n}\n\n.primaryBtn:hover {\n  background: #4f33e1;\n}\n\n.primaryBtn:disabled {\n  background: #A5B4FC;\n  color: #EEF2FF;\n  box-shadow: none;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `GateRequestSuccessModal_backdrop__aZo2R`,
	"modal": `GateRequestSuccessModal_modal__rk8He`,
	"header": `GateRequestSuccessModal_header__iFWut`,
	"title": `GateRequestSuccessModal_title__d2mWl`,
	"iconBtn": `GateRequestSuccessModal_iconBtn__XT5Cz`,
	"content": `GateRequestSuccessModal_content__RNMuP`,
	"centerBlock": `GateRequestSuccessModal_centerBlock__Z-nBD`,
	"successIcon": `GateRequestSuccessModal_successIcon__6MrOh`,
	"successTitle": `GateRequestSuccessModal_successTitle__kQufp`,
	"successSub": `GateRequestSuccessModal_successSub__oL-Op`,
	"detailsGrid": `GateRequestSuccessModal_detailsGrid__+m8f6`,
	"label": `GateRequestSuccessModal_label__cBRbI`,
	"value": `GateRequestSuccessModal_value__KFHAH`,
	"reasonBlock": `GateRequestSuccessModal_reasonBlock__sInm3`,
	"footer": `GateRequestSuccessModal_footer__0YDwq`,
	"cancelBtn": `GateRequestSuccessModal_cancelBtn__te1zV`,
	"primaryBtn": `GateRequestSuccessModal_primaryBtn__6Kqhj`
};
export default ___CSS_LOADER_EXPORT___;
